<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  orderTimeDriverChangeEdit,
} from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/operate/order/deal/orderDetailTab/driver/edit',
      formComponents: ['baseForm'],
      editParams: {
      },
    };
  },
  methods: {
    editApi: orderTimeDriverChangeEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
